import { ORDER_STATUS } from '@baemingo/order-status-events/dist/types';
import { useStorage } from '~Components/Storage';
import { useSelector } from '~Hooks';
import { Station } from '~Types';

type ReturnType = {
  selected: Station | undefined;
  all: Station[];
};

export function useStations(stationId?: string): ReturnType {
  const [storage] = useStorage();
  const allStations = useSelector((state) => state.stations);

  // If no stations exist, return empty values
  if (!allStations) {
    return { selected: undefined, all: [] };
  }

  // Find the station marked as selected in storage
  const selected = allStations.find((s) => s.id === storage.selectedKDSStation);

  return { selected, all: allStations };
}
